import type { AccentColor } from '@/api/types';

export { ACCENT_COLORS } from '@/api/types';

/**
 * Swatch colours for the fixed accent palette (§ Instellingen › Huisstijl).
 * These represent a *customer's own brand colour* for their live preview —
 * deliberately outside the app's own zwart/wit/groen token system (§
 * Ontwerpreferentie › Kleurregel is about the dashboard's own chrome, not
 * about branding a customer picks for their company). Kept as plain hex so
 * the preview renders the customer's actual choice regardless of the
 * dashboard's own light/dark theme.
 */
export const ACCENT_COLOR_SWATCHES: Record<AccentColor, string> = {
  mint: '#22c55e',
  pine: '#14532d',
  ink: '#111111',
  amber: '#f59e0b',
  coral: '#f97066',
  sky: '#38bdf8',
};
